import { Box } from '@mui/material'
import {
  brandingTileSx,
  doCompactLogoUrl,
  doCompactLogoWhiteSx,
} from './appConnectionCardConstants.js'

export function AppConnectionCardHeroBranding() {
  return (
    <Box sx={brandingTileSx} aria-hidden>
      <Box
        component="img"
        src={doCompactLogoUrl}
        alt=""
        sx={doCompactLogoWhiteSx}
        decoding="async"
      />
    </Box>
  )
}

export function AppConnectionCardHeroConnector() {
  return (
    <Box
      sx={{
        width: '100%',
        flexShrink: 0,
        borderTop: '1px dashed var(--app-border-light)',
        height: 0,
        alignSelf: 'center',
        mt: 0,
      }}
    />
  )
}
